// Navbar.tsx

import React, { useState, useEffect } from "react";
import "./Navbar.css";
import ReactCountryFlag from "react-country-flag";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

const Navbar = () => {
  const { i18n, t } = useTranslation();

  const navLinks = [
    { label: t("nav.home"), path: "/" },
    { label: t("nav.about"), path: "/about" },
    { label: t("nav.rooms"), path: "/rooms" },
    { label: t("nav.gallery"), path: "/gallery" },
    { label: t("nav.contact"), path: "/contact" },
  ];
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleNavigate = (path: string) => {
    setMenuOpen(false);
    navigate(path);
  };

  return (
    <nav className={`navbar${scrolled ? " scrolled" : ""}${menuOpen ? " menu-open" : ""}`}>
      <div className="navbarLeftContainer">
        {navLinks.map(({ label, path }) => (
          <button
            key={path}
            className={`navbar-button${location.pathname === path ? " active" : ""}`}
            onClick={() => handleNavigate(path)}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="logo" onClick={() => handleNavigate("/")}>
        <img src={process.env.PUBLIC_URL + "/logositeurl.png"} alt="Logo" />
      </div>

      <div className="navbarRightContainer">
        <ReactCountryFlag
          className="flag-dt"
          countryCode="GR"
          svg
          onClick={() => i18n.changeLanguage("el")}
          title="Greek"
        />
        <ReactCountryFlag
          className="flag-dt"
          countryCode="US"
          svg
          onClick={() => i18n.changeLanguage("en")}
          title="English"
        />
        <button
          className={`hamburger-btn${menuOpen ? " open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {/* Mobile Menu */}
      <div className={`mobileMenu${menuOpen ? " open" : ""}`} aria-hidden={!menuOpen}>
        {navLinks.map(({ label, path }, i) => (
          <button
            key={path}
            className={`navbar-button mobile${location.pathname === path ? " active" : ""}`}
            onClick={() => handleNavigate(path)}
            style={{ "--i": i } as React.CSSProperties}
          >
            {label}
          </button>
        ))}
        <div className="flags">
          <ReactCountryFlag
            className="flag-mb"
            countryCode="GR"
            svg
            onClick={() => i18n.changeLanguage("el")}
            title="Greek"
          />
          <ReactCountryFlag
            className="flag-mb"
            countryCode="US"
            svg
            onClick={() => i18n.changeLanguage("en")}
            title="English"
          />
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
